// extracted by mini-css-extract-plugin
export default {"root":"Status_root__egtTD","state0":"Status_state0__PvTz3","state1":"Status_state1__2sKiT","state2":"Status_state2__WzzPY"};